// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vectorize-preview-modal-wrapper .vm--modal{border-radius:0!important;box-shadow:0 2px 6px rgba(0,0,0,.3)!important}", ""]);
// Exports
module.exports = exports;
